<script lang="ts">
	import { T } from '@tolgee/svelte';
	import Image from '$lib/components/Image/Image.svelte';

	interface SafetyData {
		icons?: string[];
		documents?: string[];
		hstatements?: string[];
		pstatements?: string[];
		baua?: string;
		ghinweis?: string;
	}

	export let safetyData: SafetyData;
	export let sku: string;
</script>

<p>
	<T keyName="product.safety.description" />
</p>
{#if safetyData.ghinweis}
	<h6>{safetyData.ghinweis}</h6>
{/if}
<p>
	<T keyName="product.safety.articleNo" />: {sku} <br />
	{#if safetyData.baua}
		BAUA: {safetyData.baua}
	{/if}
</p>
<div class="flex flex-col gap-1">
	{#each safetyData.documents || [] as e (e)}
		<a href={e} class="flex text-accent-primary text-h-14 items-center gap-1" target="_blank">
			<div class="w-4 h-4 i-sprenger-download" />
			<T keyName="product.safety.sheet" /> (PDF)
		</a>
	{/each}
</div>
<div class="flex gap-2">
	{#each safetyData.icons || [] as e (e)}
		<Image height={32} width={32} src={e} />
	{/each}
</div>
<div>
	<h6>
		<T keyName="product.safety.danger" />
	</h6>
	<ul>
		{#each safetyData.hstatements || [] as e (e)}
			<li>{e}</li>
		{/each}
	</ul>
	<ul>
		{#each safetyData.pstatements || [] as e (e)}
			<li>{e}</li>
		{/each}
	</ul>
</div>
